import { gql } from "@apollo/client";

export const GET_ADD_TICKETS_ERROR = gql`
mutation getAddTicketsMail ($endDate: timestamptz!, $startDate: timestamptz!, $limit: Int = 10, $offset: Int = 0, $orderBy: String, $orderColumn: String, $action: String = "Add", $status: String = "Failed") {
  getTicketsMail(startDate: $startDate, endDate: $endDate, limit: $limit, offset: $offset, orderBy: $orderBy, orderColumn: $orderColumn, action: $action, status: $status) {
    ticketsData
    ticketsLength
  }
}
`;

export const GET_PUBLISH_TICKETS_ERROR=gql`
mutation getPublishTicketsMail ($endDate: timestamptz!, $startDate: timestamptz!, $limit: Int = 10, $offset: Int = 0, $orderBy: String, $orderColumn: String, $action: String = "Publish", $status: String = "Failed") {
  getTicketsMail(startDate: $startDate, endDate: $endDate, limit: $limit, offset: $offset, orderBy: $orderBy, orderColumn: $orderColumn, action: $action, status: $status) {
    ticketsData
    ticketsLength
  }
}`;

export const GET_SOLD_TICKETS_ERROR = gql`
mutation getSoldTicketsMail ($endDate: timestamptz!, $startDate: timestamptz!, $limit: Int = 10, $offset: Int = 0, $orderBy: String, $orderColumn: String, $action: String = "Sold", $status: String = "Failed") {
  getTicketsMail(startDate: $startDate, endDate: $endDate, limit: $limit, offset: $offset, orderBy: $orderBy, orderColumn: $orderColumn, action: $action, status: $status) {
    ticketsData
    ticketsLength
  }
}
`;

export const GET_STRIPE_TRANSFER_ERROR = gql`
query GetStripeErrors ($limit: Int, $offset: Int, $order_by: [stripe_errors_order_by!] = {se_date:desc}, $startDate: timestamptz, $endDate: timestamptz, $email: String = "%") {
  stripe_errors(limit: $limit, offset: $offset, order_by: $order_by, where: {_and:[{se_date:{_gte:$startDate}},{se_date:{_lte:$endDate}},{email_id:{_like:$email}},{se_deleted_at: {_is_null: true}}]}) {
    se_id
    email_id
    pt_id
    se_date
    se_reason
    u_id
    se_created_at
    se_updated_at
    payment_transaction {
      pt_id
      pt_invoice_number
      pt_quick_cut
      pt_transaction_amount
      pt_transaction_date
      pt_transaction_id
      pt_transaction_status
      pt_created_at
      pt_updated_at
      ticket_placement {
        tp_id
        tp_row
        tp_seat_no
        tp_section
        tp_status
        ticket {
          e_id
          event {
            e_id
            e_name
            e_date
            e_address
            e_cdt_date
          }
        }
      }
    }
    user {
      u_id
      u_first_name
      u_last_name
      u_email_id
      u_full_name
      u_avatar_url
      u_original_email
    }
  }
  stripe_errors_aggregate(where: {_and:[{se_date:{_gte:$startDate}},{se_date:{_lte:$endDate}},{email_id:{_like:$email}},{se_deleted_at: {_is_null: true}}]}) {
    aggregate {
      count
    }
  }
}
`;

export const GET_STRIPE_PAYOUT_ERROR = gql`
query GetPayoutErrors ($limit: Int, $offset: Int, $order_by: [payout_errors_order_by!] = {pe_created_at:desc}, $startDate: timestamptz, $endDate: timestamptz) {
  payout_errors(limit: $limit, offset: $offset, order_by: $order_by, where: {_and:[{pe_created_at:{_gte:$startDate}},{pe_created_at:{_lte:$endDate}},{pe_status: {_neq: RESOLVED}}]}) {
    pe_account_id
    pe_amount
    pe_created_at
    pe_currency
    pe_data
    pe_payout_id
    pe_reason
    pe_status
    user {
      u_email_id
      u_id
      u_first_name
      u_last_name
      u_original_email
    }
  }
  payout_errors_aggregate(where: {_and:[{pe_created_at:{_gte:$startDate}},{pe_created_at:{_lte:$endDate}},{pe_status: {_neq: RESOLVED}}]}) {
    aggregate {
      count
    }
  }
}
`

export const GET_STRIPE_PAYOUT_SUCCESS=gql`
query GetPayoutsSucceedData ($limit: Int, $offset: Int, $order_by: [payouts_succeed_order_by!] = {ps_created_at:desc}, $startDate: timestamptz, $endDate: timestamptz) {
  payouts_succeed(limit: $limit, offset: $offset, order_by: $order_by, where: {_and:[{ps_created_at:{_gte:$startDate}},{ps_created_at:{_lte:$endDate}}]}) {
    ps_account_id
    ps_amount
    ps_created_at
    ps_currency
    ps_payout_id
    ps_updated_at
    user {
      u_email_id
      u_first_name
      u_last_name
      u_id
      u_original_email
    }
  }
  payouts_succeed_aggregate(where: {_and:[{ps_created_at:{_gte:$startDate}},{ps_created_at:{_lte:$endDate}}]}) {
    aggregate {
      count
    }
  }
}`;

export const GET_SCRAP_EVENT_ERROR = gql`
  query getEventErrors(
    $pageSize: Int
    $pageNumber: Int
    $order_by: [event_errors_order_by!] = {}
    $startDate: timestamptz
    $endDate: timestamptz
  ) {
    event_errors(
      limit: $pageSize
      offset: $pageNumber
      order_by: $order_by
      where: {
        _and: [
          { ee_created_at: { _gte: $startDate } }
          { ee_created_at: { _lte: $endDate } }
        ]
      }
    ) {
      ee_id
      ee_name
      ee_reason
      ee_updated_at
      ee_description
      ee_created_at
    }
    event_errors_aggregate(
      where: {
        _and: [
          { ee_created_at: { _gte: $startDate } }
          { ee_created_at: { _lt: $endDate } }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const TRIGGER_ERROR_TICKETS=gql`
mutation TriggerErrorTickets($input: TriggerErrorTicketsInput) {
  triggerErrorTickets(triggerErrorTicketsInput: $input) {
    message
  }
}`;

export const TICKETS_LOG = gql `
query AddTicketsByAdminlog ($endDate: timestamptz!, $startDate: timestamptz!, $limit: Int = 10, $offset: Int = 0, $order_by: [AddTicketsByAdminLogs_order_by!]) {
  AddTicketByAdminLogs(limit: $limit, offset: $offset, order_by: $order_by, where: {_and:[{created_at:{_gte:$startDate}},{created_at:{_lte:$endDate}}]}) {
    bulk_operation_id
    message_id
    section
    row
    seat_no
    message
    e_name
    e_date
    e_address
    t_id
    e_id
    u_id
    u_full_name
    u_email_id
    created_at
    updated_at
  }
  AddTicketByAdminLogsCount {
    totalCount
  }
}
`;
